module.exports = __webpack_public_path__ + "img/circleBlueTick.png?7e264b01acb2ccbc1c089eeaa7e215cc";